import * as React from 'react'

import { cn } from '@/lib/utils'
import { getBaseInputClasses } from '~/@/lib/style-utils'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  isBorderless?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, disabled, isBorderless, readOnly, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          getBaseInputClasses(disabled, isBorderless, readOnly),
          'min-h-9 resize-y px-2.5 py-2',
          className,
        )}
        disabled={disabled}
        readOnly={readOnly}
        {...props}
      />
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
